export default function TabLink() {
  return (
     <div 
        aria-flowto="next-button"
        tabIndex={0}
         onFocus={()=>{
            const next_button = document.querySelector("#next-button");
            if (next_button.attributes["inert"]){ return;}
            console.log("GO TO NEXT BUTTON",next_button);
            setTimeout(() => {
                next_button.focus();
            }, 100);
        }}
      >
        
     </div>
  )
}
